import './BetbookSections.less';

import React from 'react';
import BetbookLinkBox from '@/betbook/views/BetbookLinkBox';
import i18n from '@i18n';
import { COMMUNITY_ANALYSES, COMMUNITY_TOP_EVENTS } from '@/routing/routes';
import { getConfigProperty } from '@/common/oldMobile';
import NuiTitle from 'nike-ui/src/components/nui-title/NuiTitle';
import FavoriteIcon from '@/icons/FavoriteIcon';
import {
    POST_ANALYSIS,
    SORTING_TOP,
    toBetbookPathParams,
    toBetbookQueryParams
} from 'nike-ui/src/components/betbook/constants';

const BetbookSections = () => {
    return (
        <>
            <NuiTitle title={i18n('betbook.section.ramkings')} />
            <BetbookLinkBox
                title={i18n('betbook.top.analyses')}
                route={COMMUNITY_ANALYSES}
                params={toBetbookPathParams(POST_ANALYSIS)}
                searchParams={toBetbookQueryParams({ sortType: SORTING_TOP })}
                icon={<FavoriteIcon />}
                data-atid="betbook-best-analyses"
            />
            <BetbookLinkBox
                title={i18n('betbook.topEvents.title', getConfigProperty('betbook.topEventsLimit'))}
                route={COMMUNITY_TOP_EVENTS}
                icon={<FavoriteIcon />}
                data-atid="betbook-best-top20-events"
            />
        </>
    );
};

export default BetbookSections;
